
import { useQuery } from "react-query";
import { Endpoints } from "../../enums/User/Endpoints";
import { smartposUrl } from "../ApiClient";
import { handleOpenToaster, toasterData, ErrorMessages } from "@amzn/rangoli-seller-desktop-utils/src/index";

const { GET_INVITE } = Endpoints;

interface ErrorResponse {
    status: number;
    description: string;
    message?: string;
}

const getInviteFn = async (inviteeId: string): Promise<any> => {
    try {
        const response = await smartposUrl.get(`${GET_INVITE}${inviteeId}`);
        return response.data;
    }
    catch (error: any) {  
        const errorResponse: ErrorResponse = {
            status: error?.response?.status || 500,
            description: error?.response?.data?.description || error.message,
            message: error?.message
        };
        if (errorResponse.status === 401) {
            errorResponse.description = ErrorMessages.TOKEN_EXPIRED;
        }
        // show error toast only if status 5xx
        else if (errorResponse.status >= 500) {
            handleOpenToaster({
                ...toasterData,
                type: "error",
                text: errorResponse.description || ErrorMessages.SOMETHING_WENT_WRONG,
            });
        }
        throw errorResponse;
    }
};

export const useGetInviteQuery = (inviteeId: string, isRefectchRequest?: boolean) => {
    return useQuery<any, ErrorResponse>({
        queryKey: ['inviteeId', inviteeId],
        queryFn: () => getInviteFn(inviteeId),
        refetchOnWindowFocus: false,
        enabled: !isRefectchRequest,
        retry: 1
    });
};
